import { RbacService } from '@/app/_core/domain/services/rbac/rbac.service';
import { Directive, inject, input, InputSignal, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

interface HasPermission {
  roles?: string;
  dynamicRoles?: string;
  activeModules?: string[];
  profileApplication?: string;
}

@Directive({
  selector: '[plycaRbac]',
  standalone: true
})
export class RbacDirective implements OnInit {
  public plycaRbac: InputSignal<HasPermission | null> = input.required<HasPermission>({});

  private readonly _templateRef = inject(TemplateRef);
  private readonly _viewContainer = inject(ViewContainerRef);
  private readonly _rbacService = inject(RbacService);

  ngOnInit(): void {
    const { roles, dynamicRoles, activeModules, profileApplication } = this.plycaRbac();
    const hasAccess = this._rbacService.checkRolesAndPermissions(roles, dynamicRoles, activeModules, profileApplication, true);

    if (hasAccess) {
      this._viewContainer.createEmbeddedView(this._templateRef);
    } else {
      this._viewContainer.clear();
    }
  }
}
